import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useNotification } from '../../../../../../../hooks'
import { useListingProfileContext } from '../../../RentalPortalListingProfile.hooks'
import { getListingProfileTitle } from '../../../RentalPortalListingProfile.utils'
import {
  getListingEditTitleInitialValues,
  ListingEditTitleModal,
} from '../../ListingEditTitleModal'
import { getListingProfileHeaderCoverSrc } from '../../RentalPortalListingProfileHeader.utils'

export function useListingProfileHeader() {
  const { t } = useTranslation()

  const { handleAddSuccessNotification } = useNotification()

  const {
    handleCloseModal,
    handleEntityReload,
    handleListingConflict,
    listingData,
    setModal,
  } = useListingProfileContext()

  const [failedCoverSrc, setFailedCoverSrc] = useState(null)

  const coverSrc = getListingProfileHeaderCoverSrc({
    failedSrc: failedCoverSrc,
    listingData,
  })

  const listingTitle = getListingProfileTitle({ listingData, t })

  function handleCoverError() {
    setFailedCoverSrc(coverSrc)
  }

  async function handleSaveTitle() {
    handleCloseModal()

    handleAddSuccessNotification('Notification.CommonTitleSavedKey')

    return handleEntityReload()
  }

  function handleOpenEditTitleModal() {
    setModal(
      <ListingEditTitleModal
        initialValues={getListingEditTitleInitialValues(listingTitle)}
        listingId={listingData.id}
        version={listingData.version}
        onClose={handleCloseModal}
        onConflict={handleListingConflict}
        onSave={handleSaveTitle}
      />
    )
  }

  return {
    coverSrc,
    handleCoverError,
    handleOpenEditTitleModal,
    listingTitle,
  }
}
